const suggestedProducts404 = {
    cardsContainer: false,
    cardsToShow: 4,
    url: document.location.pathname,

    start: async function () {
        if (suggestedProducts404.url.includes('/collections')) { 
            const collectionTitle = document.title || "";
            let query = suggestedProducts404.getQueryFromTitle(collectionTitle);

            if (query) {

                this.cardsContainer = document.querySelector('#collection_suggestions__container');
                if (!this.cardsContainer) {
                    document.querySelector('.collection_suggestions__outer').style.display = 'none';
                    return false;
                }

                let products = await suggestedProducts404.getProducts(query);
                suggestedProducts404.displayProductCards(products);
            }
        }
    },

    getQueryFromTitle: function(title) { 
        let words = title.split(" "); 
        let query = words.slice(0, 4).join(" "); 
        console.log("Generated query for products:", query);
        return query;
    },

    getProducts: async function(query) {
        let params = '?' +
        `q=${query}` +
        '&resources[type]=product' +
        '&resources[limit]=4' +
        '&resources[options][unavailable_products]=hide' +
        '&resources[options][fields]=title,product_type,variants.title,body';

        let suggestedProductURLs = await new Promise((resolve, reject) => {
            fetch(window.Shopify.routes.root + 'search/suggest.json' + params)
                .then((response) => response.json())
                .then((suggestions) => {
                    let productURLs = [];
                    let productSuggestions = suggestions.resources.results.products;
                    productSuggestions.forEach(product => {
                        if (product.title.startsWith("Used")) {
                            productURLs.push(product.url);
                        }
                    });
                    resolve(productURLs);
                })
                .catch((err) => console.error(err));
        });

        return suggestedProductURLs;
    },

    displayProductCards: function (productURLs) {
        if (productURLs.length) {
            const productPromises = productURLs.map(url => {
                url = url.split('?')[0];
                let fullURL = `https://${window.location.hostname}${url}?view=card`;
                return fetch(fullURL)
                    .then(response => response.text())
                    .then(response => {
                        let dummyEl = document.createElement('div');
                        dummyEl.innerHTML = response;
                        let inner = dummyEl.querySelector('.product-card-wrapper').outerHTML;
                        return inner;
                    })
                    .catch(err => console.error(err));
            });

            Promise.all(productPromises)
                .then(productItems => productItems.join(' '))
                .then(productGridInnerHTML => {
                    this.cardsContainer.innerHTML = `${productGridInnerHTML}`;
                    document.querySelector('.collection_suggestions__outer').style.display = 'block';
                });
        } else {
            document.querySelector('.collection_suggestions__outer').style.display = 'none';
        }
    }
};

suggestedProducts404.start();
